// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import type { SymbolGlyphProps } from './glyph';
import { MachineLetter, RotatingMachine } from './RotatingMachine';

/**
 * Generator set — a rotating machine, lettered `G`. IEC 60617 / IEEE 315.
 *
 * Circle-with-a-letter is the universal convention for rotating machines, and
 * pairing `G` here with `M` on `MotorSymbol` is what makes the pair readable
 * without a legend. This deliberately diverges from the AI Summit mock, which
 * drew the genset as a green rectangle: the rectangle carried its meaning by
 * colour, and colour is reserved for status.
 */
export const GeneratorSymbol = ({ size = 18, run, leads }: SymbolGlyphProps) => (
  <RotatingMachine size={size} run={run} leads={leads}>
    <MachineLetter letter="G" />
  </RotatingMachine>
);
